var map = {
	"./404.png": "8f20",
	"./background.png": "b874",
	"./cookie.png": "fa08",
	"./css.png": "0ff0",
	"./eye.png": "7da9",
	"./glasses.png": "c48f",
	"./hand.png": "c5cc",
	"./home.png": "1815",
	"./lesson.png": "d123",
	"./magic.png": "564e",
	"./newLesson.png": "7269",
	"./save.png": "a0ce",
	"./see.png": "00eec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";